export default {
  title: "Items",
  subtitle: "Item Overview",
  tab_attached: "Attached",
  tab_data: "Data",
  tab_location: "Location",
  tab_overview: "Overview",
  identification: "Identification",
  item: "Item",
  item_id: "Item ID",
  item_class: "Item Class",
  location_id: "Location ID",
  issues: "Issues",
  issues_open: "Open Issues",
  work_orders: "Work Orders",
  data_changes: "Data changes",
  location_changes: "Location changes",
  attachment_changes: "Attachment changes",
  location: "Location",
  id: "ID",
  designation: "Designation",
  model: "Model",
  manufacturer: "Manufacturer",
  dialog_location_title: "No location found",
  dialog_location_text: "There is no location associated with the current item",
  update_item: "Item successfully updated",
  error_value_unique: "Value must be unique",
  error_form: "Some of the fields above have errors. Please fix them in order to submit",
  promoted_items: "Promoted Items",
  remaining_items: "Remaining Items",
}
